import { useState } from 'react';
import { Button, Field, Input, Modal } from '@/components/ui';

/** Модалка подтверждения админ-действия с обязательной причиной (пишется в аудит). */
export function ReasonModal({
  open,
  title,
  action,
  onClose,
  onConfirm,
}: {
  open: boolean;
  title: string;
  action: string;
  onClose(): void;
  onConfirm(reason: string): Promise<void>;
}) {
  const [reason, setReason] = useState('');
  const [pending, setPending] = useState(false);
  return (
    <Modal open={open} onClose={onClose} title={title}>
      <form
        className="space-y-4"
        onSubmit={async (e) => {
          e.preventDefault();
          setPending(true);
          await onConfirm(reason.trim()).finally(() => setPending(false));
          setReason('');
        }}
      >
        <Field label="Причина" hint="Сохраняется в журнале действий администраторов">
          <Input value={reason} onChange={(e) => setReason(e.target.value)} autoFocus maxLength={500} />
        </Field>
        <Button type="submit" variant="primary" className="w-full" disabled={!reason.trim()} loading={pending}>
          {action}
        </Button>
      </form>
    </Modal>
  );
}
